import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { lightTheme, darkTheme } from '@/themes/defaultThemes';

const theme = {
  themes: {
    light: lightTheme,
    dark: darkTheme,
  },
  options: {
    customProperties: true,
  },
};

Vue.use(Vuetify);

export default new Vuetify({
  theme,
});
